import "ngstorage";
import auth from "../../services/auth.js";
import companies from "../../services/companies.js";
import security from "../../services/security.js";
import env from "../../services/env.js";

const fakeInvoices = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25];
const sortingStatus = {
  invoiceIdSortStatus: {
    default: true,
    asc: false,
    desc: false,
  },
  amountSortStatus: {
    default: true,
    asc: false,
    desc: false,
  },
  invoiceDateSortStatus: {
    default: false,
    asc: false,
    desc: true,
  },
  paymentMethodSortStatus: {
    default: true,
    asc: false,
    desc: false,
  },
};

const sortingStatusBilling = {
  payDate: {
    default: false,
    asc: true,
    desc: false,
  },
  jobblerNameSortStatus: {
    default: true,
    asc: false,
    desc: false,
  },
  hoursSortStatus: {
    default: true,
    asc: false,
    desc: false,
  },
  rateSortStatus: {
    default: true,
    asc: false,
    desc: false,
  },
  jobblerPaidSortStatus: {
    default: true,
    asc: false,
    desc: false,
  },
  platformFeeSortStatus: {
    default: true,
    asc: false,
    desc: false,
  },
  totalChargeSortStatus: {
    default: true,
    asc: false,
    desc: false,
  },
  eventIdSortStatus: {
    default: true,
    asc: false,
    desc: false,
  },
};

class BillingController {
  constructor(
    $http,
    $localStorage,
    $state,
    $stateParams,
    AuthService,
    CompaniesService,
    SecurityService,
    ProfileService,
    $timeout,
    $rootScope,
    EnvService,
    ngProgressFactory,
    $scope,
    $location
  ) {
    this.name = "accountprofile";

    $localStorage.activeStateName = "accountprofile";

    if (!AuthService.isLoggedIn()) {
      $state.go("signin");
      return;
    }

    this.$http = $http;
    this.$localStorage = $localStorage;
    this.$state = $state;
    this.$timeout = $timeout;
    this.$scope = $scope;
    this.$auth = AuthService;
    this.$companies = CompaniesService;
    this.$security = SecurityService;
    this.$profile = ProfileService;
    this.$progress = ngProgressFactory.createInstance();
    this.$rootScope = $rootScope;
    this.$location = $location;
    this.$env = EnvService;
    this.currentUser = this.$auth.getUserData();
    this.fakeInvoices = fakeInvoices;
    this.sortingStatus = sortingStatus;
    this.sortingStatusBilling = sortingStatusBilling;
    this.$stateParams = $stateParams;
    this.doWeHaveAtLeastOneInvoice = false;

    this.sortingParameters = {
      offset: 0,
      sort: "invoiceDate",
      order: "desc",
      max: 30,
      search: null,
      start: null,
      end: null,
    };

    this.sortingParametersBill = {
      offset: 0,
      sort: "payment_date_created",
      order: "asc",
      max: 30,
      search: null,
      start: null,
      end: null,
    };

    this.uiViews = {is_loading: true, all_checked: false, one_checked_invoice: false};
    this.invoiceViewList = [];
    var _this = this;
    this.init();
  }

  init() {
    let billId = this.$state.params.billId;

    if (billId) {
      this.showUsers = true;
      this.sortingParametersBill.billId = billId;
      //this.getUsersLatestTutorialData(this.currentUser);
      this.formatInvoiceStartDate(this.$location.$$search);
      this.getBill(null, true);
    } else {
      this.showUsers = false;
      this.getUsersLatestTutorialData(this.currentUser);
      this.getPendingInvoices();
      this.getInvoices();
      //this.initTutorial(this.currentUser);
    }
  }

  initTutorial(user) {
    console.log("init tutorial");
    console.dir(this.doWeHaveAtLeastOneInvoice);

    if (this.doWeHaveAtLeastOneInvoice === false) {
      return;
    } else {
      this.doWeHaveAtLeastOneInvoice = false;
    }

    this.$profile.getLatestTutorial().then(
      (response) => {
        if (response.data.billingTutorialTracking === false || response.data.billingTutorialTracking === null) {
          this.$timeout(() => {
            $("#tutorial-modal.tutorial-1").addClass("show-tutorial");
            this.doWeHaveAtLeastOneInvoice = false;
          });
        }
      },
      (error) => {
        alert("Error loading users payment information : " + error.status);
      }
    );
  }

  formatInvoiceStartDate(dateObj) {
    this.payPeriodBeginning = moment(new Date(dateObj.startDate)).format("MM/DD/YYYY");
    this.payPeriodEnding = moment(new Date(dateObj.endDate)).format("MM/DD/YYYY");
    this.billCsvName = "Jobble_Invoice_" + this.payPeriodBeginning + "-" + this.payPeriodEnding + ".csv";
  }

  getBill(params, totalUp, forBillingPage) {
    console.log("getBill");
    console.dir(params);
    console.dir(this.sortingParametersBill);
    console.dir(forBillingPage);

    this.start();

    let data = null;

    if (params) {
      data = params;
    } else {
      data = this.sortingParametersBill;
    }

    this.$companies.getBill(data).then(
      (response) => {
        this.formatBills(response, response.data, totalUp, forBillingPage);
      },
      (error) => {
        alert("Error : " + error);
        this.finish();
      }
    );
  }

  getInvoices(params) {
    this.start();

    let data = null;

    if (params) {
      data = params;
    } else {
      data = this.sortingParameters;
    }

    this.$companies.getInvoices(data).then(
      (response) => {
        console.log("response");
        console.dir(response);

        if (response && response.data && response.data.invoices.length > 0) {
          this.doWeHaveAtLeastOneInvoice = true;
          this.initTutorial(this.currentUser);
        }

        this.totalNumberOfInvoices = response.data.totalRegisters;

        if (this.totalNumberOfInvoices === 0) {
          this.finish();
        } else {
          this.formatInvoices(response, response.data);
        }
      },
      (error) => {
        alert("Error : " + error);
        this.finish();
      }
    );
  }

  getPendingInvoices() {
    //this.start();
    let startDate = this.getBeginningOfWeek();
    let endDate = this.getEndOfWeek();

    console.log("pending invoice params");
    console.dir(startDate);
    console.dir(endDate);

    this.$companies.getPendingInvoices(startDate, endDate).then(
      (response) => {
        console.log("pending invoices response");
        console.dir(response);
        this.formatPendingInvoice(response, startDate, endDate);
      },
      (error) => {
        alert("Error : " + error);
      }
    );
  }

  formatPendingInvoice(response, start, end) {
    console.log("formatPendingInvoice");
    console.dir(response);
    let today = moment();

    if (response && response.data && response.data.length > 0) {
      this.doWeHaveAtLeastOneInvoice = true;
      this.initTutorial(this.currentUser);
    }

    let totalAmountToBeCharged = this.calculateAmountOfPendingCharges(response);

    let pendingBill = {
      start: today.startOf("week").add(1, "days").format("MM/DD/YYYY"),
      end: today.endOf("week").format("MM/DD/YYYY"),
      total: totalAmountToBeCharged,
    };

    this.pendingBill = pendingBill;
  }

  calculateAmountOfPendingCharges(response) {
    console.log("calculateAmountOfPendingCharges");
    console.dir(response);

    let payments = response.data.pendingInvoicePayments;
    let total = 0;

    try {
      payments.forEach(function (payment) {
        total = total + payment.totalCharge;
      });
    } catch (err) {
      console.log("problem with the invoices :" + err);
    } finally {
      console.log("total payments");
      console.dir(total);
      total = total.toFixed(2);
      total = numeral(total).format("$0,0.00");
      return total;
    }
  }

  getBeginningOfWeek() {
    let today = moment();
    let beginning = today.startOf("week").format("YYYY-MM-DD");

    return beginning;
  }

  getEndOfWeek() {
    let today = moment();
    let end = today.endOf("week").format("YYYY-MM-DD");

    return end;
  }

  formatRate(rate) {
    let r = null;

    if (rate === "N/A") {
      r = "--";
    } else {
      r = rate;
    }

    return r;
  }

  enableToolTips() {
    this.$timeout(() => {
      console.log("enableToolTips");
      console.dir($(".invoice-tool-tip"));

      $(".history-tool-tip").tooltip({});
      $(".invoice-tool-tip").tooltip({});
    }, 1000);
  }

  formatBills(response, data, totalUp, forBillingPage) {
    let bills = data.invoiceDetails;

    this.billsViewList = [];

    if (totalUp) {
      this.total = 0;
    }

    try {
      for (let index = 0; index < bills.length; index++) {
        let bill = bills[index];
        let billView = {};

        console.log("each bill");
        console.dir(bill);

        billView.eventId = bill.eventId;
        billView.shiftDate = this.formatShiftStartDate(bill);
        billView.paymentDate = this.formatPaymentDate(bill.payment_date_created);
        billView.name = bill.jobblerName;
        billView.rate = this.formatRate(bill.rate);
        billView.hours = bill.hours;
        billView.isAdditionalPayment = bill.is_additional_payment;
        billView.jobblerPaid = this.formatInvoiceAmount(bill.jobblerPaid);
        billView.platformFee = this.formatInvoiceAmount(bill.platformFee);
        billView.totalCharge = this.formatInvoiceAmount(bill.totalCharge);
        billView.tooltip = this.formatToolTip(bill);
        billView.memo = bill.memo;

        this.billsViewList.push(billView);

        if (totalUp === true) {
          this.totalAllCharges(bill.totalCharge);
        }
      }
    } catch (err) {
      console.log("Error formatting bills :", err);
    } finally {
      this.finish();
      this.enableToolTips();
      this.prepBillsForCSV(this.billsViewList, forBillingPage);
      if (totalUp === true) {
        this.formatTotal();
      }
    }
  }

  activateDatePicker() {
    const elem = document.getElementById("range-selection-2");

    if (!elem) return;

    this.datepicker = new DateRangePicker(elem, {
      minDate: new Date(),
    });
  }

  formatShiftStartDate(bill) {
    let shiftDate = bill.shiftStartDate;
    let dateObject = new Date(shiftDate);
    let momentDateFormatted = moment(dateObject).format("MM-DD-YYYY");
    if (bill.shiftStartDate) {
      return momentDateFormatted;
    } else {
      return "N/A";
    }
  }

  formatPaymentDate(date) {
    let dateObject = new Date(date);
    let momentDateFormatted = moment(dateObject).format("MM-DD-YYYY");

    return momentDateFormatted;
  }

  formatToolTip(bill) {
    let shiftDate = bill.shiftStartDate;
    let dateObject = new Date(shiftDate);
    let momentDateFormatted = moment(dateObject).format("MM-DD-YYYY");
    let toolTipFormatted =
      "<strong>Event ID:</strong> " +
      bill.eventId +
      "<br/> <strong>Location:</strong> " +
      bill.location +
      "<br/> <strong>Title:</strong> " +
      bill.title;

    return toolTipFormatted;
  }

  prepBillsForCSV(bills, forBillingPage) {

    var _this = this;

    let csv = [];

    _this.csv = [];

    try {
      bills.forEach(function (bill, i) {
        let csvObj = {
          pay_date: bill.paymentDate,
          name: bill.name,
          rate: bill.rate,
          hours: bill.hours,
          jobbler_paid: bill.jobblerPaid,
          platformFee: bill.platformFee,
          total_charge: bill.totalCharge,
          shift_date: bill.shiftDate,
          event_id: bill.eventId,
          memo: bill.memo,
        };

        csv.push(csvObj);
      });
    } catch (err) {
    } finally {
      this.setAccountLevelDetails(csv);
      _this.csv = csv;
      return csv;
    }
  }

  setAccountLevelDetails(csv) {
    let cvsAddition = [];
    let blankSpace = {};
    let accountInfo = {
      account: "Account",
      value: this.currentUser.company.name,
    };

    let accountId = {
      account: "Account ID",
      value: this.currentUser.company.id,
    };

    let invoiceData = {
      invoice: "Invoice #",
      value: this.sortingParametersBill.billId,
    };

    let dateRangeData = {
      date: "Date Range",
      value: this.payPeriodBeginning + " - " + this.payPeriodEnding,
    };

    csv.push(blankSpace);
    csv.push(accountInfo);
    csv.push(accountId);
    csv.push(invoiceData);
    csv.push(dateRangeData);

    this.csv = csv;

  }

  getHeaderBills() {
    return ["Pay Date", "Jobbler", "Rate", "Hours", "Jobbler Paid", "Platform Fee", "Total Charge", "Shift Date", "Event ID", "Memo"];
  }

  formatTotal() {
    this.$timeout(() => {
      this.total = this.total / 100;
      this.total = this.formatInvoiceAmount(this.total);
    }, 600);
  }

  formatInvoices(formatInvoicesResponse, data) {
    let invoices = data.invoices;

    this.invoiceViewList = [];

    try {
      for (let index = 0; index < invoices.length; index++) {
        let invoice = invoices[index];
        let invoiceView = {};

        invoiceView.id = invoice.invoiceId;
        invoiceView.amount = this.formatInvoiceAmount(invoice.amount / 100);
        invoiceView.periodStartRaw = invoice.period_start;
        invoiceView.periodEndRaw = invoice.period_end;
        invoiceView.invoiceDateRaw = this.formatInvoiceDateProcessed(invoice.invoiceDate);
        invoiceView.paymentMethod = invoice.paymentMethod;
        invoiceView.status = invoice.status;
        invoiceView.statusClass = this.formatStatusClass(invoice.status);
        invoiceView.isChecked = false;
        let billingPeriod = this.formateInvoiceDate(invoice.invoiceDate, invoice, index);
        invoiceView.periodStart = billingPeriod.startPeriod;
        invoiceView.periodEnd = billingPeriod.endPeriod;

        if (index === 0) {
          invoiceView.invoiceDateForView = invoiceView.invoiceDateForView + " (current)";
        }

        this.invoiceViewList.push(invoiceView);
      }
    } catch (err) {
      console.error("issue with the invoices");
      console.dir(err);
    } finally {
      this.activateDatePicker();
      this.enableToolTips();
      this.finish();
    }
  }

  totalAllCharges(charge) {
    let div = charge * 100;
    this.$timeout(() => {
      this.total = this.total + div;
    }, 500);
  }

  formatInvoiceAmount(amount) {
    return numeral(amount).format("$0,0.00");
  }

  formatInvoiceDateProcessed(date) {
    return moment(date).format("MM/DD/YYYY");
  }

  formatStatusClass(status) {
    let result = "";

    if (status === "PAID") {
      result = "paid";
    } else {
      result = "";
    }

    return result;
  }

  formateInvoiceDate(date, invoice, index) {
    let dateObj = {};

    let startDate = new Date(invoice.period_start);
    let endDate = new Date(invoice.period_end);
    dateObj.startPeriod = moment(startDate).add(1, "days").format("MM/DD/YYYY");
    dateObj.endPeriod = moment(endDate).format("MM/DD/YYYY");

    return dateObj;
  }

  finish() {
    this.uiViews.is_loading = false;
    this.unSetLoader();
    this.fancyLoad();
  }

  goToBillingDetails(invoice, index) {

  }

  toggleActionMenu(invoice, index) {
    let i = index + 2;

    this.$timeout(() => {
      $(
        ".jobs-dashboard-container .jobs-dashboard-jobs-listing table.jobs-dashboard-jobs-table.invoices tbody tr:nth-child(" +
          i +
          ") td:last-child .action-menu"
      ).slideToggle({duration: 100});
    });

    this.$timeout(() => {
      $(".jobs-dashboard-container .jobs-dashboard-jobs-listing table.jobs-dashboard-jobs-table.invoices tbody tr:nth-child(" + i + ") td").addClass(
        "row-focus"
      );
    }, 150);

    this.$timeout(() => {
      $(
        ".jobs-dashboard-container .jobs-dashboard-jobs-listing table.jobs-dashboard-jobs-table.invoices tbody tr:nth-child(" +
          i +
          ") td:last-child .action-menu"
      ).focus();
    }, 300);
  }

  closeActionMenu(invoice, index) {
    let i = index + 1;

    this.$timeout(() => {
      $(
        ".jobs-dashboard-container .jobs-dashboard-jobs-listing table.jobs-dashboard-jobs-table.invoices tbody tr:nth-child(" +
          i +
          ") td:last-child .action-menu"
      ).hide();
      $(
        ".jobs-dashboard-container .jobs-dashboard-jobs-listing table.jobs-dashboard-jobs-table.invoices tbody tr:nth-child(" + i + ") td"
      ).removeClass("row-focus");
    }, 150);
  }

  sortTableBill(field) {
    let params = {
      offset: 0,
      sort: "payDate",
      order: "asc",
      max: 30,
      search: null,
      start: null,
      end: null,
      billId: this.$state.params.billId,
    };

    if (field === "payDate") {
      if (this.sortingStatusBilling.payDate.default === true) {
        this.sortingStatusBilling.payDate.default = false;
        this.sortingStatusBilling.payDate.asc = true;
        this.sortingStatusBilling.payDate.desc = false;

        this.sortingStatusBilling.jobblerNameSortStatus.default = true;
        this.sortingStatusBilling.jobblerNameSortStatus.asc = false;
        this.sortingStatusBilling.jobblerNameSortStatus.desc = false;

        this.sortingStatusBilling.rateSortStatus.default = true;
        this.sortingStatusBilling.rateSortStatus.asc = false;
        this.sortingStatusBilling.rateSortStatus.desc = false;

        this.sortingStatusBilling.hoursSortStatus.default = true;
        this.sortingStatusBilling.hoursSortStatus.asc = false;
        this.sortingStatusBilling.hoursSortStatus.desc = false;

        this.sortingStatusBilling.jobblerPaidSortStatus.default = true;
        this.sortingStatusBilling.jobblerPaidSortStatus.asc = false;
        this.sortingStatusBilling.jobblerPaidSortStatus.desc = false;

        this.sortingStatusBilling.platformFeeSortStatus.default = true;
        this.sortingStatusBilling.platformFeeSortStatus.asc = false;
        this.sortingStatusBilling.platformFeeSortStatus.desc = false;

        this.sortingStatusBilling.totalChargeSortStatus.default = true;
        this.sortingStatusBilling.totalChargeSortStatus.asc = false;
        this.sortingStatusBilling.totalChargeSortStatus.desc = false;

        this.sortingStatusBilling.eventIdSortStatus.default = true;
        this.sortingStatusBilling.eventIdSortStatus.asc = false;
        this.sortingStatusBilling.eventIdSortStatus.desc = false;

        params.sort = "payment_date_created";
        params.order = "asc";

        this.getBill(params);
      } else if (this.sortingStatusBilling.payDate.desc === true) {
        this.sortingStatusBilling.payDate.default = false;
        this.sortingStatusBilling.payDate.asc = true;
        this.sortingStatusBilling.payDate.desc = false;

        params.sort = "payment_date_created";
        params.order = "asc";

        this.getBill(params);
      } else if (this.sortingStatusBilling.payDate.asc === true) {
        this.sortingStatusBilling.payDate.default = false;
        this.sortingStatusBilling.payDate.asc = false;
        this.sortingStatusBilling.payDate.desc = true;

        params.sort = "payment_date_created";
        params.order = "desc";

        this.getBill(params);
      }
    } else if (field === "jobbler") {
      if (this.sortingStatusBilling.jobblerNameSortStatus.default === true) {
        this.sortingStatusBilling.payDate.default = true;
        this.sortingStatusBilling.payDate.asc = false;
        this.sortingStatusBilling.payDate.desc = false;

        this.sortingStatusBilling.jobblerNameSortStatus.default = false;
        this.sortingStatusBilling.jobblerNameSortStatus.asc = false;
        this.sortingStatusBilling.jobblerNameSortStatus.desc = true;

        this.sortingStatusBilling.rateSortStatus.default = true;
        this.sortingStatusBilling.rateSortStatus.asc = false;
        this.sortingStatusBilling.rateSortStatus.desc = false;

        this.sortingStatusBilling.hoursSortStatus.default = true;
        this.sortingStatusBilling.hoursSortStatus.asc = false;
        this.sortingStatusBilling.hoursSortStatus.desc = false;

        this.sortingStatusBilling.jobblerPaidSortStatus.default = true;
        this.sortingStatusBilling.jobblerPaidSortStatus.asc = false;
        this.sortingStatusBilling.jobblerPaidSortStatus.desc = false;

        this.sortingStatusBilling.platformFeeSortStatus.default = true;
        this.sortingStatusBilling.platformFeeSortStatus.asc = false;
        this.sortingStatusBilling.platformFeeSortStatus.desc = false;

        this.sortingStatusBilling.totalChargeSortStatus.default = true;
        this.sortingStatusBilling.totalChargeSortStatus.asc = false;
        this.sortingStatusBilling.totalChargeSortStatus.desc = false;

        this.sortingStatusBilling.eventIdSortStatus.default = true;
        this.sortingStatusBilling.eventIdSortStatus.asc = false;
        this.sortingStatusBilling.eventIdSortStatus.desc = false;

        params.sort = "jobblerName";
        params.order = "desc";

        this.getBill(params);
      } else if (this.sortingStatusBilling.jobblerNameSortStatus.desc === true) {
        this.sortingStatusBilling.jobblerNameSortStatus.default = false;
        this.sortingStatusBilling.jobblerNameSortStatus.asc = true;
        this.sortingStatusBilling.jobblerNameSortStatus.desc = false;

        params.sort = "jobblerName";
        params.order = "asc";

        this.getBill(params);
      } else if (this.sortingStatusBilling.jobblerNameSortStatus.asc === true) {
        this.sortingStatusBilling.jobblerNameSortStatus.default = true;
        this.sortingStatusBilling.jobblerNameSortStatus.asc = false;
        this.sortingStatusBilling.jobblerNameSortStatus.desc = false;

        this.sortingStatusBilling.eventIdSortStatus.default = false;
        this.sortingStatusBilling.eventIdSortStatus.desc = true;

        params.sort = "payment_date_created";
        params.order = "desc";

        this.getBill(params);
      }
    } else if (field === "rate") {
      if (this.sortingStatusBilling.rateSortStatus.default === true) {
        this.sortingStatusBilling.payDate.default = true;
        this.sortingStatusBilling.payDate.asc = false;
        this.sortingStatusBilling.payDate.desc = false;

        this.sortingStatusBilling.jobblerNameSortStatus.default = true;
        this.sortingStatusBilling.jobblerNameSortStatus.asc = false;
        this.sortingStatusBilling.jobblerNameSortStatus.desc = false;

        this.sortingStatusBilling.rateSortStatus.default = false;
        this.sortingStatusBilling.rateSortStatus.asc = false;
        this.sortingStatusBilling.rateSortStatus.desc = true;

        this.sortingStatusBilling.hoursSortStatus.default = true;
        this.sortingStatusBilling.hoursSortStatus.asc = false;
        this.sortingStatusBilling.hoursSortStatus.desc = false;

        this.sortingStatusBilling.jobblerPaidSortStatus.default = true;
        this.sortingStatusBilling.jobblerPaidSortStatus.asc = false;
        this.sortingStatusBilling.jobblerPaidSortStatus.desc = false;

        this.sortingStatusBilling.platformFeeSortStatus.default = true;
        this.sortingStatusBilling.platformFeeSortStatus.asc = false;
        this.sortingStatusBilling.platformFeeSortStatus.desc = false;

        this.sortingStatusBilling.totalChargeSortStatus.default = true;
        this.sortingStatusBilling.totalChargeSortStatus.asc = false;
        this.sortingStatusBilling.totalChargeSortStatus.desc = false;

        this.sortingStatusBilling.eventIdSortStatus.default = true;
        this.sortingStatusBilling.eventIdSortStatus.asc = false;
        this.sortingStatusBilling.eventIdSortStatus.desc = false;

        params.sort = "rate";
        params.order = "desc";

        this.getBill(params);
      } else if (this.sortingStatusBilling.rateSortStatus.desc === true) {
        this.sortingStatusBilling.rateSortStatus.default = false;
        this.sortingStatusBilling.rateSortStatus.asc = true;
        this.sortingStatusBilling.rateSortStatus.desc = false;

        params.sort = "rate";
        params.order = "asc";

        this.getBill(params);
      } else if (this.sortingStatusBilling.rateSortStatus.asc === true) {
        this.sortingStatusBilling.rateSortStatus.default = true;
        this.sortingStatusBilling.rateSortStatus.asc = false;
        this.sortingStatusBilling.rateSortStatus.desc = false;

        this.sortingStatusBilling.eventIdSortStatus.default = false;
        this.sortingStatusBilling.eventIdSortStatus.desc = true;

        params.sort = "payment_date_created";
        params.order = "desc";

        this.getBill(params);
      }
    } else if (field === "hours") {
      if (this.sortingStatusBilling.hoursSortStatus.default === true) {
        this.sortingStatusBilling.payDate.default = true;
        this.sortingStatusBilling.payDate.asc = false;
        this.sortingStatusBilling.payDate.desc = false;

        this.sortingStatusBilling.jobblerNameSortStatus.default = true;
        this.sortingStatusBilling.jobblerNameSortStatus.asc = false;
        this.sortingStatusBilling.jobblerNameSortStatus.desc = false;

        this.sortingStatusBilling.rateSortStatus.default = true;
        this.sortingStatusBilling.rateSortStatus.asc = false;
        this.sortingStatusBilling.rateSortStatus.desc = false;

        this.sortingStatusBilling.hoursSortStatus.default = false;
        this.sortingStatusBilling.hoursSortStatus.asc = false;
        this.sortingStatusBilling.hoursSortStatus.desc = true;

        this.sortingStatusBilling.jobblerPaidSortStatus.default = true;
        this.sortingStatusBilling.jobblerPaidSortStatus.asc = false;
        this.sortingStatusBilling.jobblerPaidSortStatus.desc = false;

        this.sortingStatusBilling.platformFeeSortStatus.default = true;
        this.sortingStatusBilling.platformFeeSortStatus.asc = false;
        this.sortingStatusBilling.platformFeeSortStatus.desc = false;

        this.sortingStatusBilling.totalChargeSortStatus.default = true;
        this.sortingStatusBilling.totalChargeSortStatus.asc = false;
        this.sortingStatusBilling.totalChargeSortStatus.desc = false;

        this.sortingStatusBilling.eventIdSortStatus.default = true;
        this.sortingStatusBilling.eventIdSortStatus.asc = false;
        this.sortingStatusBilling.eventIdSortStatus.desc = false;

        params.sort = "hours";
        params.order = "desc";

        this.getBill(params);
      } else if (this.sortingStatusBilling.hoursSortStatus.desc === true) {
        this.sortingStatusBilling.hoursSortStatus.default = false;
        this.sortingStatusBilling.hoursSortStatus.asc = true;
        this.sortingStatusBilling.hoursSortStatus.desc = false;

        params.sort = "hours";
        params.order = "asc";

        this.getBill(params);
      } else if (this.sortingStatusBilling.hoursSortStatus.asc === true) {
        this.sortingStatusBilling.hoursSortStatus.default = true;
        this.sortingStatusBilling.hoursSortStatus.asc = false;
        this.sortingStatusBilling.hoursSortStatus.desc = false;

        this.sortingStatusBilling.eventIdSortStatus.default = false;
        this.sortingStatusBilling.eventIdSortStatus.desc = true;

        params.sort = "payment_date_created";
        params.order = "desc";

        this.getBill(params);
      }
    } else if (field === "jobblerPaid") {
      if (this.sortingStatusBilling.jobblerPaidSortStatus.default === true) {
        this.sortingStatusBilling.payDate.default = true;
        this.sortingStatusBilling.payDate.asc = false;
        this.sortingStatusBilling.payDate.desc = false;

        this.sortingStatusBilling.jobblerNameSortStatus.default = true;
        this.sortingStatusBilling.jobblerNameSortStatus.asc = false;
        this.sortingStatusBilling.jobblerNameSortStatus.desc = false;

        this.sortingStatusBilling.rateSortStatus.default = true;
        this.sortingStatusBilling.rateSortStatus.asc = false;
        this.sortingStatusBilling.rateSortStatus.desc = false;

        this.sortingStatusBilling.hoursSortStatus.default = true;
        this.sortingStatusBilling.hoursSortStatus.asc = false;
        this.sortingStatusBilling.hoursSortStatus.desc = false;

        this.sortingStatusBilling.jobblerPaidSortStatus.default = false;
        this.sortingStatusBilling.jobblerPaidSortStatus.asc = false;
        this.sortingStatusBilling.jobblerPaidSortStatus.desc = true;

        this.sortingStatusBilling.platformFeeSortStatus.default = true;
        this.sortingStatusBilling.platformFeeSortStatus.asc = false;
        this.sortingStatusBilling.platformFeeSortStatus.desc = false;

        this.sortingStatusBilling.totalChargeSortStatus.default = true;
        this.sortingStatusBilling.totalChargeSortStatus.asc = false;
        this.sortingStatusBilling.totalChargeSortStatus.desc = false;

        this.sortingStatusBilling.eventIdSortStatus.default = true;
        this.sortingStatusBilling.eventIdSortStatus.asc = false;
        this.sortingStatusBilling.eventIdSortStatus.desc = false;

        params.sort = "jobblerPaid";
        params.order = "desc";

        this.getBill(params);
      } else if (this.sortingStatusBilling.jobblerPaidSortStatus.desc === true) {
        this.sortingStatusBilling.jobblerPaidSortStatus.default = false;
        this.sortingStatusBilling.jobblerPaidSortStatus.asc = true;
        this.sortingStatusBilling.jobblerPaidSortStatus.desc = false;

        params.sort = "jobblerPaid";
        params.order = "asc";

        this.getBill(params);
      } else if (this.sortingStatusBilling.jobblerPaidSortStatus.asc === true) {
        this.sortingStatusBilling.jobblerPaidSortStatus.default = true;
        this.sortingStatusBilling.jobblerPaidSortStatus.asc = false;
        this.sortingStatusBilling.jobblerPaidSortStatus.desc = false;

        this.sortingStatusBilling.eventIdSortStatus.default = false;
        this.sortingStatusBilling.eventIdSortStatus.desc = true;

        params.sort = "payment_date_created";
        params.order = "desc";

        this.getBill(params);
      }
    } else if (field === "platformFee") {
      if (this.sortingStatusBilling.platformFeeSortStatus.default === true) {
        this.sortingStatusBilling.payDate.default = true;
        this.sortingStatusBilling.payDate.asc = false;
        this.sortingStatusBilling.payDate.desc = false;

        this.sortingStatusBilling.jobblerNameSortStatus.default = true;
        this.sortingStatusBilling.jobblerNameSortStatus.asc = false;
        this.sortingStatusBilling.jobblerNameSortStatus.desc = false;

        this.sortingStatusBilling.rateSortStatus.default = true;
        this.sortingStatusBilling.rateSortStatus.asc = false;
        this.sortingStatusBilling.rateSortStatus.desc = false;

        this.sortingStatusBilling.hoursSortStatus.default = true;
        this.sortingStatusBilling.hoursSortStatus.asc = false;
        this.sortingStatusBilling.hoursSortStatus.desc = false;

        this.sortingStatusBilling.jobblerPaidSortStatus.default = true;
        this.sortingStatusBilling.jobblerPaidSortStatus.asc = false;
        this.sortingStatusBilling.jobblerPaidSortStatus.desc = false;

        this.sortingStatusBilling.platformFeeSortStatus.default = false;
        this.sortingStatusBilling.platformFeeSortStatus.asc = false;
        this.sortingStatusBilling.platformFeeSortStatus.desc = true;

        this.sortingStatusBilling.totalChargeSortStatus.default = true;
        this.sortingStatusBilling.totalChargeSortStatus.asc = false;
        this.sortingStatusBilling.totalChargeSortStatus.desc = false;

        this.sortingStatusBilling.eventIdSortStatus.default = true;
        this.sortingStatusBilling.eventIdSortStatus.asc = false;
        this.sortingStatusBilling.eventIdSortStatus.desc = false;

        params.sort = "platformFee";
        params.order = "desc";

        this.getBill(params);
      } else if (this.sortingStatusBilling.platformFeeSortStatus.desc === true) {
        this.sortingStatusBilling.platformFeeSortStatus.default = false;
        this.sortingStatusBilling.platformFeeSortStatus.asc = true;
        this.sortingStatusBilling.platformFeeSortStatus.desc = false;

        params.sort = "platformFee";
        params.order = "asc";

        this.getBill(params);
      } else if (this.sortingStatusBilling.platformFeeSortStatus.asc === true) {
        this.sortingStatusBilling.platformFeeSortStatus.default = true;
        this.sortingStatusBilling.platformFeeSortStatus.asc = false;
        this.sortingStatusBilling.platformFeeSortStatus.desc = false;

        this.sortingStatusBilling.eventIdSortStatus.default = false;
        this.sortingStatusBilling.eventIdSortStatus.desc = true;

        params.sort = "payment_date_created";
        params.order = "desc";

        this.getBill(params);
      }
    } else if (field === "totalCharge") {
      if (this.sortingStatusBilling.totalChargeSortStatus.default === true) {
        this.sortingStatusBilling.payDate.default = true;
        this.sortingStatusBilling.payDate.asc = false;
        this.sortingStatusBilling.payDate.desc = false;

        this.sortingStatusBilling.jobblerNameSortStatus.default = true;
        this.sortingStatusBilling.jobblerNameSortStatus.asc = false;
        this.sortingStatusBilling.jobblerNameSortStatus.desc = false;

        this.sortingStatusBilling.rateSortStatus.default = true;
        this.sortingStatusBilling.rateSortStatus.asc = false;
        this.sortingStatusBilling.rateSortStatus.desc = false;

        this.sortingStatusBilling.hoursSortStatus.default = true;
        this.sortingStatusBilling.hoursSortStatus.asc = false;
        this.sortingStatusBilling.hoursSortStatus.desc = false;

        this.sortingStatusBilling.jobblerPaidSortStatus.default = true;
        this.sortingStatusBilling.jobblerPaidSortStatus.asc = false;
        this.sortingStatusBilling.jobblerPaidSortStatus.desc = false;

        this.sortingStatusBilling.platformFeeSortStatus.default = true;
        this.sortingStatusBilling.platformFeeSortStatus.asc = false;
        this.sortingStatusBilling.platformFeeSortStatus.desc = false;

        this.sortingStatusBilling.totalChargeSortStatus.default = false;
        this.sortingStatusBilling.totalChargeSortStatus.asc = false;
        this.sortingStatusBilling.totalChargeSortStatus.desc = true;

        this.sortingStatusBilling.eventIdSortStatus.default = true;
        this.sortingStatusBilling.eventIdSortStatus.asc = false;
        this.sortingStatusBilling.eventIdSortStatus.desc = false;

        params.sort = "totalCharge";
        params.order = "desc";

        this.getBill(params);
      } else if (this.sortingStatusBilling.totalChargeSortStatus.desc === true) {
        this.sortingStatusBilling.totalChargeSortStatus.default = false;
        this.sortingStatusBilling.totalChargeSortStatus.asc = true;
        this.sortingStatusBilling.totalChargeSortStatus.desc = false;

        params.sort = "totalCharge";
        params.order = "asc";

        this.getBill(params);
      } else if (this.sortingStatusBilling.totalChargeSortStatus.asc === true) {
        this.sortingStatusBilling.totalChargeSortStatus.default = true;
        this.sortingStatusBilling.totalChargeSortStatus.asc = false;
        this.sortingStatusBilling.totalChargeSortStatus.desc = false;

        this.sortingStatusBilling.eventIdSortStatus.default = false;
        this.sortingStatusBilling.eventIdSortStatus.desc = true;

        params.sort = "payment_date_created";
        params.order = "desc";

        this.getBill(params);
      }
    } else if (field === "eventId") {
      if (this.sortingStatusBilling.eventIdSortStatus.default === true) {
        this.sortingStatusBilling.payDate.default = true;
        this.sortingStatusBilling.payDate.asc = false;
        this.sortingStatusBilling.payDate.desc = false;

        this.sortingStatusBilling.jobblerNameSortStatus.default = true;
        this.sortingStatusBilling.jobblerNameSortStatus.asc = false;
        this.sortingStatusBilling.jobblerNameSortStatus.desc = false;

        this.sortingStatusBilling.rateSortStatus.default = true;
        this.sortingStatusBilling.rateSortStatus.asc = false;
        this.sortingStatusBilling.rateSortStatus.desc = false;

        this.sortingStatusBilling.hoursSortStatus.default = true;
        this.sortingStatusBilling.hoursSortStatus.asc = false;
        this.sortingStatusBilling.hoursSortStatus.desc = false;

        this.sortingStatusBilling.jobblerPaidSortStatus.default = true;
        this.sortingStatusBilling.jobblerPaidSortStatus.asc = false;
        this.sortingStatusBilling.jobblerPaidSortStatus.desc = false;

        this.sortingStatusBilling.platformFeeSortStatus.default = true;
        this.sortingStatusBilling.platformFeeSortStatus.asc = false;
        this.sortingStatusBilling.platformFeeSortStatus.desc = false;

        this.sortingStatusBilling.totalChargeSortStatus.default = true;
        this.sortingStatusBilling.totalChargeSortStatus.asc = false;
        this.sortingStatusBilling.totalChargeSortStatus.desc = false;

        this.sortingStatusBilling.eventIdSortStatus.default = false;
        this.sortingStatusBilling.eventIdSortStatus.asc = false;
        this.sortingStatusBilling.eventIdSortStatus.desc = true;

        params.sort = "shiftStartDate";
        params.order = "desc";

        this.getBill(params);
      } else if (this.sortingStatusBilling.eventIdSortStatus.desc === true) {
        this.sortingStatusBilling.eventIdSortStatus.default = false;
        this.sortingStatusBilling.eventIdSortStatus.asc = true;
        this.sortingStatusBilling.eventIdSortStatus.desc = false;

        params.sort = "shiftStartDate";
        params.order = "asc";

        this.getBill(params);
      } else if (this.sortingStatusBilling.eventIdSortStatus.asc === true) {
        this.sortingStatusBilling.eventIdSortStatus.default = true;
        this.sortingStatusBilling.eventIdSortStatus.asc = false;
        this.sortingStatusBilling.eventIdSortStatus.desc = false;

        params.sort = "payment_date_created";
        params.order = "desc";

        this.getBill(params);
      }
    }
  }

  sortTable(field) {
    let params = {offset: 0, sort: "invoiceDate", order: "desc", max: 30, search: null, start: null, end: null};

    if (field === "invoiceId") {
      if (this.sortingStatus.invoiceIdSortStatus.default === true) {
        this.sortingStatus.invoiceIdSortStatus.default = false;
        this.sortingStatus.invoiceIdSortStatus.asc = false;
        this.sortingStatus.invoiceIdSortStatus.desc = true;

        this.sortingStatus.amountSortStatus.default = true;
        this.sortingStatus.amountSortStatus.asc = false;
        this.sortingStatus.amountSortStatus.desc = false;

        this.sortingStatus.invoiceDateSortStatus.default = true;
        this.sortingStatus.invoiceDateSortStatus.asc = false;
        this.sortingStatus.invoiceDateSortStatus.desc = false;

        this.sortingStatus.paymentMethodSortStatus.default = true;
        this.sortingStatus.paymentMethodSortStatus.asc = false;
        this.sortingStatus.paymentMethodSortStatus.desc = false;

        params.sort = "invoiceId";
        params.order = "desc";

        this.getInvoices(params);
      } else if (this.sortingStatus.invoiceIdSortStatus.desc === true) {
        this.sortingStatus.invoiceIdSortStatus.default = false;
        this.sortingStatus.invoiceIdSortStatus.asc = true;
        this.sortingStatus.invoiceIdSortStatus.desc = false;

        params.sort = "invoiceId";
        params.order = "asc";

        this.getInvoices(params);
      } else if (this.sortingStatus.invoiceIdSortStatus.asc === true) {
        this.sortingStatus.invoiceIdSortStatus.default = true;
        this.sortingStatus.invoiceIdSortStatus.asc = false;
        this.sortingStatus.invoiceIdSortStatus.desc = false;

        params.sort = "invoiceDate";
        params.order = "desc";

        this.getInvoices(params);
      }
    } else if (field === "amount") {
      if (this.sortingStatus.amountSortStatus.default === true) {
        this.sortingStatus.invoiceIdSortStatus.default = true;
        this.sortingStatus.invoiceIdSortStatus.asc = false;
        this.sortingStatus.invoiceIdSortStatus.desc = false;

        this.sortingStatus.amountSortStatus.default = false;
        this.sortingStatus.amountSortStatus.asc = false;
        this.sortingStatus.amountSortStatus.desc = true;

        this.sortingStatus.invoiceDateSortStatus.default = true;
        this.sortingStatus.invoiceDateSortStatus.asc = false;
        this.sortingStatus.invoiceDateSortStatus.desc = false;

        this.sortingStatus.paymentMethodSortStatus.default = true;
        this.sortingStatus.paymentMethodSortStatus.asc = false;
        this.sortingStatus.paymentMethodSortStatus.desc = false;

        params.sort = "amount";
        params.order = "desc";

        this.getInvoices(params);
      } else if (this.sortingStatus.amountSortStatus.desc === true) {
        this.sortingStatus.amountSortStatus.default = false;
        this.sortingStatus.amountSortStatus.asc = true;
        this.sortingStatus.amountSortStatus.desc = false;

        params.sort = "amount";
        params.order = "asc";

        this.getInvoices(params);
      } else if (this.sortingStatus.amountSortStatus.asc === true) {
        this.sortingStatus.amountSortStatus.default = true;
        this.sortingStatus.amountSortStatus.asc = false;
        this.sortingStatus.amountSortStatus.desc = false;

        params.sort = "invoiceDate";
        params.order = "desc";

        this.getInvoices(params);
      }
    } else if (field === "date") {
      if (this.sortingStatus.invoiceDateSortStatus.default === true) {
        this.sortingStatus.invoiceIdSortStatus.default = true;
        this.sortingStatus.invoiceIdSortStatus.asc = false;
        this.sortingStatus.invoiceIdSortStatus.desc = false;

        this.sortingStatus.amountSortStatus.default = true;
        this.sortingStatus.amountSortStatus.asc = false;
        this.sortingStatus.amountSortStatus.desc = false;

        this.sortingStatus.invoiceDateSortStatus.default = false;
        this.sortingStatus.invoiceDateSortStatus.asc = false;
        this.sortingStatus.invoiceDateSortStatus.desc = true;

        this.sortingStatus.paymentMethodSortStatus.default = true;
        this.sortingStatus.paymentMethodSortStatus.asc = false;
        this.sortingStatus.paymentMethodSortStatus.desc = false;

        params.sort = "invoiceDate";
        params.order = "desc";

        this.getInvoices(params);
      } else if (this.sortingStatus.invoiceDateSortStatus.desc === true) {
        this.sortingStatus.invoiceDateSortStatus.default = false;
        this.sortingStatus.invoiceDateSortStatus.asc = true;
        this.sortingStatus.invoiceDateSortStatus.desc = false;

        params.sort = "invoiceDate";
        params.order = "asc";

        this.getInvoices(params);
      } else if (this.sortingStatus.invoiceDateSortStatus.asc === true) {
        this.sortingStatus.invoiceDateSortStatus.default = true;
        this.sortingStatus.invoiceDateSortStatus.asc = false;
        this.sortingStatus.invoiceDateSortStatus.desc = false;

        params.sort = "invoiceDate";
        params.order = "desc";

        this.getInvoices(params);
      }
    } else if (field === "payment") {
      if (this.sortingStatus.paymentMethodSortStatus.default === true) {
        this.sortingStatus.invoiceIdSortStatus.default = true;
        this.sortingStatus.invoiceIdSortStatus.asc = false;
        this.sortingStatus.invoiceIdSortStatus.desc = false;

        this.sortingStatus.amountSortStatus.default = true;
        this.sortingStatus.amountSortStatus.asc = false;
        this.sortingStatus.amountSortStatus.desc = false;

        this.sortingStatus.invoiceDateSortStatus.default = true;
        this.sortingStatus.invoiceDateSortStatus.asc = false;
        this.sortingStatus.invoiceDateSortStatus.desc = false;

        this.sortingStatus.paymentMethodSortStatus.default = false;
        this.sortingStatus.paymentMethodSortStatus.asc = false;
        this.sortingStatus.paymentMethodSortStatus.desc = true;

        this.getInvoices();
      } else if (this.sortingStatus.paymentMethodSortStatus.desc === true) {
        this.sortingStatus.paymentMethodSortStatus.default = false;
        this.sortingStatus.paymentMethodSortStatus.asc = true;
        this.sortingStatus.paymentMethodSortStatus.desc = false;

        this.getInvoices();
      } else if (this.sortingStatus.paymentMethodSortStatus.asc === true) {
        this.sortingStatus.paymentMethodSortStatus.default = true;
        this.sortingStatus.paymentMethodSortStatus.asc = false;
        this.sortingStatus.paymentMethodSortStatus.desc = false;

        this.getInvoices();
      }
    }
  }

  checkAll() {
    if (this.uiViews.all_checked === false) {
      this.uiViews.all_checked = true;
      this.checkOrUncheckAll(true);
    } else {
      this.uiViews.all_checked = false;
      this.checkOrUncheckAll(false);
    }

    this.checkForAtleastOneCheckedInvoice();
  }

  checkOrUncheckAll(checked) {
    this.invoiceViewList.forEach(function (invoice) {
      invoice.isChecked = checked;
    });
  }

  checkForAtleastOneCheckedInvoice() {
    var _this = this;

    _this.invoiceViewList.forEach(function (invoice) {
      if (invoice.isChecked !== true) {
        _this.uiViews.one_checked_invoice = false;
      }
    });

    _this.invoiceViewList.forEach(function (invoice) {
      if (invoice.isChecked === true) {
        _this.uiViews.one_checked_invoice = true;
      }
    });
  }

  start() {
    this.setLoader();
  }

  setLoader() {
    this.$timeout(() => {
      $("html").addClass("wait");
    });
  }

  unSetLoader() {
    this.$timeout(() => {
      $("html").removeClass("wait");
    });
  }

  invoiceSearchSubmit() {
    let params = {
      offset: 0,
      sort: "invoiceDate",
      order: "desc",
      max: 30,
      search: this.billingSearch,
      start: null,
      end: null,
    };

    this.getInvoices(params);
  }

  goToBill(id, bill) {
    //this.billDate = bill.invoiceDateForView;
    //this.$state.go("bill", {"billId" : id});
  }

  billSearchSubmit() {
    let params = {
      offset: 0,
      sort: "eventId",
      order: "desc",
      max: 30,
      search: this.billSearch,
      start: null,
      end: null,
      billId: this.$state.params.billId,
    };

    this.getBill(params);
  }

  fancyLoad() {
    /*
    this.$timeout(() => {
      $(".jobs-dashboard-container .jobs-dashboard-jobs-listing table.jobs-dashboard-jobs-table tbody tr").hide();
    });
    */

    this.$timeout(() => {
      $(".jobs-dashboard-container .jobs-dashboard-jobs-listing table.jobs-dashboard-jobs-table tbody tr").each(function (index) {
        $(this)
          .delay(index * 10)
          .show(50);
      });
    }, 200);
  }

  exitTutorial(step) {
    if (step === 1) {
      this.$timeout(() => {
        $("#tutorial-modal.tutorial-1").addClass("exit-tutorial");
      });
    } else if (step === 2) {
      this.$timeout(() => {
        $("#tutorial-modal.tutorial-2").addClass("exit-tutorial");
      });
    } else if (step === 3) {
      this.$timeout(() => {
        $("#tutorial-modal.tutorial-3").addClass("exit-tutorial");
      });
    } else if (step === 4) {
      this.$timeout(() => {
        $("#tutorial-modal.tutorial-4").addClass("exit-tutorial");
      });
    } else if (step === 5) {
      this.$timeout(() => {
        $("#tutorial-modal.tutorial-5").removeClass("show-tutorial");
        $("#tutorial-modal.tutorial-5").addClass("exit-tutorial");
      });
    } else if (step === 6) {
      this.$timeout(() => {
        $("#tutorial-modal.tutorial-5").removeClass("show-tutorial");
        $("#tutorial-modal.tutorial-5").addClass("exit-tutorial");
      });
    } else if (step === 7) {
      this.$timeout(() => {
        $("#tutorial-modal.tutorial-6").removeClass("show-tutorial");
        $("#tutorial-modal.tutorial-6").addClass("exit-tutorial");
      });
    } else if (step === 8) {
      this.$timeout(() => {
        $("#tutorial-modal.tutorial-8").removeClass("show-tutorial");
        $("#tutorial-modal.tutorial-8").addClass("exit-tutorial");
      });
    }

    this.updateTutorialTracking(true);
  }

  updateTutorialTracking(stopTutorial) {

    let userBillingInfo = {billingTutorialTracking: stopTutorial};

    this.$profile.saveUser(userBillingInfo).then(
      (response) => {
        this.$timeout(() => {
          this.getUsersLatestTutorialData(this.currentUser, userBillingInfo);
        }, 1000);
      },
      function (error) {
        console.log("in error");
        console.dir(error);
      }
    );
  }

  getUsersLatestTutorialData(user, userBillingInfo) {
    this.$auth.refreshCurrentUserBilling().then(
      (response) => {
        if (response.billingTutorialTracking === true || (userBillingInfo && userBillingInfo.billingTutorialTracking === true)) {
        } else {
          this.continueTutorial(5, null);
        }
      },
      function (error) {
        console.log("in error");
        console.dir(error);
      }
    );
  }

  continueTutorial(step, invoice) {
    console.log("continueTutorial");
    console.dir(step);

    if (step === 1) {
      this.$timeout(() => {
        $("#tutorial-modal.tutorial-1").addClass("exit-tutorial");
        $("#tutorial-modal.tutorial-2").addClass("show-tutorial");
      });
    } else if (step === 2) {
      this.$timeout(() => {
        $("#tutorial-modal.tutorial-2").addClass("exit-tutorial");
        $("#tutorial-modal.tutorial-3").addClass("show-tutorial");
      });
    } else if (step === 3) {
      this.$timeout(() => {
        $("#tutorial-modal.tutorial-3").addClass("exit-tutorial");
        $("#tutorial-modal.tutorial-4").addClass("show-tutorial");
      });
    } else if (step === 4) {
      this.$timeout(() => {
        $("#tutorial-modal.tutorial-4").addClass("exit-tutorial");
      });
    } else if (step === 5) {
      this.$timeout(() => {
        $("#tutorial-modal.tutorial-5").addClass("show-tutorial");
      });
    } else if (step === 6) {
      this.$timeout(() => {
        $("#tutorial-modal.tutorial-5").removeClass("show-tutorial");
        $("#tutorial-modal.tutorial-5").addClass("exit-tutorial");
        $("#tutorial-modal.tutorial-6").addClass("show-tutorial");
      });
    } else if (step === 7) {
      this.$timeout(() => {
        $("#tutorial-modal.tutorial-6").removeClass("show-tutorial");
        $("#tutorial-modal.tutorial-6").addClass("exit-tutorial");
        $("#tutorial-modal.tutorial-7").addClass("show-tutorial");
      });
    } else if (step === 8) {
      this.$timeout(() => {
        $("#tutorial-modal.tutorial-7").removeClass("show-tutorial");
        $("#tutorial-modal.tutorial-7").addClass("exit-tutorial");
        $("#tutorial-modal.tutorial-8").addClass("show-tutorial");
        this.updateTutorialTracking(true);
      });
    }
  }

  exportbill(invoice) {
    console.log("export bill");
    console.dir(invoice);

    this.csv = null;
    this.billCsvName = null;
    let dateObj = {};
    dateObj.startDate = invoice.periodStartRaw;
    dateObj.endDate = invoice.periodEndRaw;

    this.formatInvoiceStartDate(dateObj);

    if (invoice) {
      let data = {
        billId: invoice.id,
        end: null,
        max: 100,
        offset: 0,
        order: "asc",
        search: null,
        sort: "payment_date_created",
        start: null,
      };

      return new Promise((resolve, reject) => {
        this.$companies.getBill(data).then(
          (response) => {
            console.log("what is resolved..");
            console.dir(response);

            let bills = response.data.invoiceDetails;
            let formattedBills = [];

            try {
              for (let index = 0; index < bills.length; index++) {
                let bill = bills[index];
                let billView = {};

                billView.eventId = bill.eventId;
                billView.shiftDate = this.formatShiftStartDate(bill);
                billView.paymentDate = this.formatPaymentDate(bill.payment_date_created);
                billView.name = bill.jobblerName;
                billView.rate = this.formatRate(bill.rate);
                billView.hours = bill.hours;
                billView.jobblerPaid = this.formatInvoiceAmount(bill.jobblerPaid);
                billView.platformFee = this.formatInvoiceAmount(bill.platformFee);
                billView.totalCharge = this.formatInvoiceAmount(bill.totalCharge);
                billView.tooltip = this.formatToolTip(bill);
                billView.memo = bill.memo;

                formattedBills.push(billView);
              }
            } catch (err) {
              console.log("Error formatting bills :", err);
            } finally {
              this.finish();
              let csv = [];

              try {
                formattedBills.forEach(function (bill, i) {
                  let csvObj = {
                    pay_date: bill.paymentDate,
                    name: bill.name,
                    rate: bill.rate,
                    hours: bill.hours,
                    jobbler_paid: bill.jobblerPaid,
                    platformFee: bill.platformFee,
                    total_charge: bill.totalCharge,
                    shift_date: bill.shiftDate,
                    event_id: bill.eventId,
                    memo: bill.memo,
                  };
                  csv.push(csvObj);
                });
              } catch (err) {
              } finally {
                this.setAccountLevelDetails(csv);
                console.log("do we have csv");
                console.dir(csv);

                resolve(csv);
              }
            }
          },
          (error) => {
            console.error(error);
            reject();
          }
        );
      });
    }
  }
}

BillingController.$inject = [
  "$http",
  "$localStorage",
  "$state",
  "$stateParams",
  "auth",
  "companies",
  "security",
  "profile",
  "$timeout",
  "$rootScope",
  "env",
  "ngProgressFactory",
  "$scope",
  "$location",
];

export default BillingController;



// WEBPACK FOOTER //
// ./client/app/components/billing/billing.controller.js